import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { LeagueIterationMemberService } from 'src/app/simulator-booking/services/league-iteration-member.service';
import { LeagueIterationService } from 'src/app/simulator-booking/services/league-iteration.service';
import { LeagueMemberService } from 'src/app/simulator-booking/services/league-member.service';
import { League } from 'src/app/simulator-booking/models/league';
import { LeagueMember } from 'src/app/simulator-booking/models/league-member';
import { LeagueIteration } from 'src/app/simulator-booking/models/league-iteration';
import { LeagueMemberList } from 'src/app/simulator-booking/models/league-member';

@Component({
    selector: 'add-members-to-iteration-modal',
    templateUrl: './add-members-to-iteration-modal.component.html',
    styleUrl: './add-members-to-iteration-modal.component.scss',
    standalone: false
})
export class AddMembersToIterationModalComponent extends BaseModalComponent implements OnInit {

    public league: League;
    public iteration: LeagueIteration;
    public preselectedMembers: LeagueMember[] = [];
    public availableMembers: LeagueMemberList[] = [];
    public iterations: LeagueIteration[] = [];
    public selectedMembers: string[] = [];
    public selectedIterationId: string = '';
    public errorMessage: string = '';

    public form = new FormGroup({
        iterationId: new FormControl('', {
            validators: []
        })
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { league: League, members?: LeagueMember[], iteration?: LeagueIteration },
        private sessionService: SessionService,
        private leagueIterationMemberService: LeagueIterationMemberService,
        private leagueIterationService: LeagueIterationService,
        private leagueMemberService: LeagueMemberService,
        public dialogRef: MatDialogRef<AddMembersToIterationModalComponent>
    ) {
        super();
        this.league = data.league;
        this.iteration = data.iteration;
        this.preselectedMembers = data.members || [];
        this.isDarkMode = !this.sessionService.getUser().defaultTheme;
    }

    ngOnInit(): void {

        // Pre-select iteration if provided
        if (this.iteration && this.iteration.id) {
            this.selectedIterationId = this.iteration.id;
        }

        // Pre-select members if provided
        if (this.preselectedMembers.length > 0) {
            this.availableMembers = this.data.members;
            this.selectedMembers = this.preselectedMembers.map(m => m.id);
            this.getAvailableIterations();
        } else {
            this.loadIterations();
            this.loadAvailableMembers();
        }
    }

    loadIterations(): void {
        this.isLoading = true;
        this.leagueIterationService.getAllByLeagueId({
            leagueId: this.league.id,
            organizationId: this.sessionService.getUser().organizationId
        } as any).subscribe({
            next: (result: any) => {
                this.iterations = result.results || [];
                this.isLoading = false;
            },
            error: (error: any) => {
                console.error('Error loading iterations:', error);
                this.isLoading = false;
            }
        });
    }

    loadAvailableMembers(): void {
        this.isLoading = true;
        const query = {
            leagueId: this.league.id,
            leagueIterationId: this.iteration.id
        };
        this.leagueMemberService.getAvailableByLeagueIterationId(query).subscribe({
            next: (result: any) => {
                this.availableMembers = result || [];
                this.isLoading = false;
            },
            error: (error: any) => {
                console.error('Error loading members:', error);
                this.isLoading = false;
            }
        });
    }

    getAvailableIterations(): void {
        this.isLoading = true;
        this.leagueIterationService.getAvailableByMemberId(this.selectedMembers[0]).subscribe({
            next: (result: any) => {
                this.iterations = result || [];
                this.isLoading = false;
            },
            error: (error: any) => {
                console.error('Error loading iterations:', error);
                this.isLoading = false;
            }
        });
    }

    toggleMemberSelection(memberId: string): void {
        const index = this.selectedMembers.indexOf(memberId);
        if (index > -1) {
            this.selectedMembers.splice(index, 1);
        } else {
            this.selectedMembers.push(memberId);
        }
    }

    isMemberSelected(memberId: string): boolean {
        return this.selectedMembers.includes(memberId);
    }

    submit(): void {
        if (!this.selectedIterationId || this.selectedMembers.length === 0) {
            return;
        }

        this.isLoading = true;
        const data = {
            leagueIterationId: this.selectedIterationId,
            leagueMemberIds: this.selectedMembers,
            organizationId: this.sessionService.getUser().organizationId,
            createdBy: this.sessionService.getUserId()
        };
        this.errorMessage = '';
        this.leagueIterationMemberService.addMembersToIteration(data).subscribe({
            next: (result) => {
                if (result !== null && result !== undefined) {
                    this.dialogRef.close("save");
                }
            },
            error: (error) => {
                console.error('Error adding members to iteration:', error);
                error.error.forEach((error: any) => {
                    this.errorMessage += error.errorMessage;
                });
                this.isLoading = false;
            },
            complete: () => this.isLoading = false
        });
    }
}

